import { useState, useEffect, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import CategoriesContext from '../context'

const TicketPage = ({ editMode }) => {
  const baseURL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/tickets'
  const [formData, setFormData] = useState({
    status: 'Pending ...',
    progress: 0,
    timestamp: new Date().toISOString(),
  })
  const { categories } = useContext(CategoriesContext)
  const navigate = useNavigate()
  let { id } = useParams()

  const handleChange = (e) => {
    const value = e.target.value
    const name = e.target.name

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (editMode) {
      const response = await axios.put(`${baseURL}/${id}`, {
        data: {...formData, category: formData.category || (categories && categories[0]) || 'Misc.'},
      })
      const success = response.status === 200
      if (success) {
        navigate('/')
      }
    }
    if (!editMode) {
      const response = await axios.post(baseURL, {
        formData : {...formData, category: formData.category || (categories && categories[0]) || 'Misc.'},
      })
      const success = (response.status === 200)
      if (success) {
        navigate('/')
      }
    }
  }

  const fetchData = async () => {
    const response = await axios.get(`${baseURL}/${id}`)
    setFormData(response.data.data)
  }

  useEffect(() => {
    if (editMode) {
      fetchData()
    }
  }, [])

  return (
    <div className="ticket">
      <h1>{editMode ? 'Update Ticket' : 'New Ticket'}</h1>
      <div className="ticket-container">
        <form onSubmit={handleSubmit}>
          <section>
            <label htmlFor="title">Title</label>
            <input
              autoFocus
              id="title"
              name="title"
              type="text"
              onChange={handleChange}
              required={true}
              value={formData.title}
            />

            <label htmlFor="description">Description</label>
            <input
              id="description"
              name="description"
              type="text"
              onChange={handleChange}
              required={true}
              value={formData.description}
            />

            <label>Category</label>
            <select
              name="category"
              value={formData.category || (categories && categories[0]) || 'Misc.'}
              onChange={handleChange}
            >
              {categories?.map((category, _index) => (
                <option key={_index} value={category}>{category}</option>
              ))}
            </select>

            <label htmlFor="new-category">New Category</label>
            <input
              id="new-category"
              name="category"
              type="text"
              onChange={handleChange}
              value={formData.category || (categories && categories[0]) || 'Misc.'}
            />

            <label>Priority</label>
            <div className="multiple-input-container">
              <input
                id="priority-1"
                name="priority"
                type="radio"
                onChange={handleChange}
                value={1}
                checked={formData.priority == 1}
              />
              <label htmlFor="priority-1">1</label>
              <input
                id="priority-2"
                name="priority"
                type="radio"
                onChange={handleChange}
                value={2}
                checked={formData.priority == 2}
              />
              <label htmlFor="priority-2">2</label>
              <input
                id="priority-3"
                name="priority"
                type="radio"
                onChange={handleChange}
                value={3}
                checked={formData.priority == 3}
              />
              <label htmlFor="priority-3">3</label>
              <input
                id="priority-4"
                name="priority"
                type="radio"
                onChange={handleChange}
                value={4}
                checked={formData.priority == 4}
              />
              <label htmlFor="priority-4">4</label>
              <input
                id="priority-5"
                name="priority"
                type="radio"
                onChange={handleChange}
                value={5}
                checked={formData.priority == 5}
              />
              <label htmlFor="priority-5">5</label>
            </div>

            {editMode && (
              <>
                <input
                  type="range"
                  id="progress"
                  name="progress"
                  value={formData.progress}
                  min="0"
                  max="100"
                  onChange={handleChange}
                />
                <label htmlFor="progress">Progress</label>

                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option defaultValue={formData.status == 'Complete ✅'} value="Complete ✅">
                    Complete ✅
                  </option>
                  <option
                    defaultValue={formData.status == 'In Progress'}
                    value="In Progress"
                  >
                    In Progress
                  </option>
                  <option defaultValue={formData.status == 'Stuck ❗'} value="Stuck ❗">
                    Stuck ❗
                  </option>
                  <option
                    defaultValue={formData.status == 'Pending ...'}
                    value="Pending ..."
                  >
                    Pending ...
                  </option>
                </select>
              </>
            )}

            <input type="submit" />
          </section>

          <section>
            <label htmlFor="owner">Owner</label>
            <input
              id="owner"
              name="owner"
              type="owner"
              onChange={handleChange}
              required={true}
              value={formData.owner}
            />

            <label htmlFor="avatar">Avatar</label>
            <input
              id="avatar"
              name="avatar"
              type="url"
              onChange={handleChange}
            />
            <div className="img-preview">
              {formData.avatar && (
                <img src={formData.avatar} alt="preview" />
              )}
            </div>
          </section>
        </form>
      </div>
    </div>
  )
}

export default TicketPage
